import source from '../assets/source.json';

const poems = source.poets.map(x => x.poems).flat();

export function getById(id) {
    const poem = poems.filter(x => x.id === id)[0];
    return poem;
}

export function getByPoetId(id) {
    const poetsPoems = poems.filter(x => x.poetId === id);
    return poetsPoems;
}

export function getPoemsByTag(tag) {
    const poemsWithTag = poems.filter(x => x.audio).filter(x => x.tags.some(x => x === tag));
    return poemsWithTag;
}

export function getPoemsByTagsList(tagsList) {
    let poems = [];
    tagsList.forEach(tag => getPoemsByTag(tag).forEach(poem => poems.push(poem)));
    return poems;
}

export function getAllPoems() {
    return poems.filter(x => x.audio);
}